import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {IProduct} from 'app/blocks/model/product.model';
import {ProductAtrribute} from 'app/blocks/model/product-attirbute.model';

export class WhitelistAttributeCombination {
    id: number;
    attributes: ProductAtrribute[];

    constructor(productAttributes?) {
        if (productAttributes) {
            this.id = productAttributes.id;
            this.attributes = productAttributes.attributes.sort((a, b) => a.attributeType.localeCompare(b.attributeType));
        }
    }
}

export class AttributeWhitelistItem {
    id: number;
    product: IProduct;
    combinations: WhitelistAttributeCombination[];

    constructor(productAttributes?) {
        if (productAttributes) {
            this.id = productAttributes.id;
            this.product = productAttributes.product;
            this.combinations = productAttributes.combinations?.map((combination) => new WhitelistAttributeCombination(combination)) ?? [];
        }
    }
}

export interface IAttributeWhitelist extends IBaseEntity {
    id: number;
    name: string;
    description: string;
    items: AttributeWhitelistItem[];
}

export class AttributeWhitelist extends BaseEntity implements IAttributeWhitelist {
    public id: number;
    public name: string;
    public description: string;
    public items: AttributeWhitelistItem[];
    constructor(attributeWhiteList?) {
        super();
        if (attributeWhiteList) {
            this.id = attributeWhiteList.id;
            this.name = attributeWhiteList.name;
            this.description = attributeWhiteList.description;
            this.items = attributeWhiteList.items;
        } else {
            this.items = [];
        }
    }
    get discriminator(): any {
        return this.name;
    }

    clone(): AttributeWhitelist {
        return new AttributeWhitelist(this);
    }
}
